import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {styled} from "@mui/material/styles";

import CustomTooltip from "components/CustomTooltip";
import {ReactComponent as ChartBars} from "assets/img/chart-bars.svg";
import {ReactComponent as InfoCircle} from "assets/img/info-circle.svg";
import {
    green50,
    green100,
    green500,
    orange50,
    orange100,
    orange500,
    red50,
    red100,
    red500
} from "assets/jss/main";

ListingDemandTile.propTypes = {
    // groupedSearchImpression tier from the ES document (0 = no data)
    groupedSearchImpression: PropTypes.number,
};

const LEVELS = {
    low: {labelId: "retailer.product.list.demand.low", color: red500, backgroundColor: red50, borderColor: red100},
    medium: {labelId: "retailer.product.list.demand.medium", color: orange500, backgroundColor: orange50, borderColor: orange100},
    high: {labelId: "retailer.product.list.demand.high", color: green500, backgroundColor: green50, borderColor: green100},
};

// tiers 2 and 3 (Moyen − / Moyen +) share the same tile, the detail lives in
// the tooltip; tier 0 (no data) shows no tile at all
const getLevel = (groupedSearchImpression) => {
    switch (groupedSearchImpression) {
        case 4:
            return LEVELS.high;
        case 3:
        case 2:
            return LEVELS.medium;
        case 1:
            return LEVELS.low;
        default:
            return null;
    }
};

const Tile = styled('div', {shouldForwardProp: (prop) => 'level' !== prop})(({level}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    width: '100%',
    height: '20px',
    padding: '0 8px',
    backgroundColor: level.backgroundColor,
    border: `1px solid ${level.borderColor}`,
    borderRadius: '4px',
    color: level.color,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    'svg': {
        display: 'block',
        flexShrink: 0
    }
}));

const StyledChartBars = styled(ChartBars)({
    flexShrink: 0,
    'path': {
        fill: 'currentColor'
    }
});

// styled() forwards the ref the tooltip needs to anchor itself
const InfoIcon = styled(InfoCircle)({
    width: '12px',
    height: '12px',
    flexShrink: 0,
    'path': {
        stroke: 'currentColor'
    }
});

function ListingDemandTile({groupedSearchImpression = 0}) {
    const level = getLevel(groupedSearchImpression);

    if (null === level) {
        return null;
    }

    return (
        <Tile level={level}>
            <StyledChartBars/>
            <FormattedMessage id={level.labelId}/>
            <CustomTooltip title={<FormattedMessage id={"retailer.product.list.demand.tooltip"}/>}>
                <InfoIcon/>
            </CustomTooltip>
        </Tile>
    );
}

export default ListingDemandTile;
